import { useTranslation } from 'react-i18next'
import { useCurrentLanguage } from '../../util'
import { Helmet } from 'react-helmet-async'
import k from '../../i18n/keys'
import React from 'react'

export const TopLevelLanguageAndMeta = () => {
  const { t } = useTranslation()
  const currentLanguage = useCurrentLanguage()
  return (
    <>
      <Helmet>
        <html lang={currentLanguage} />
        <meta name="description" content={t(k.THESSA_IS_THE_DOCTORAL_STUDIES)} />
      </Helmet>
    </>
  )
}
